import { App, defineAsyncComponent } from 'vue';

const IntersectionObserver = defineAsyncComponent(() => import('./IntersectionObserver.vue'));
const TypingAnimation = defineAsyncComponent(() => import('./TypingAnimation.vue'));

export default function config(app: App): void {
    app.component('IntersectionObserver', IntersectionObserver);
    app.component('TypingAnimation', TypingAnimation);
}
